import React, { ReactNode } from 'react';

import ContactHelper from '../../core/libs/ContactHelper';
import { openUrl, ThirdPartyIcon, ThirdPartyName } from '../../core/libs/utils';
import {
  ThirdPartyIdText,
  ViewContactCaption,
  ViewContactField,
  ViewContactThirdPartyIcon
} from '../styled/ContactsForm';

import { TAppContact, TAppThirdPartyId } from 'TProtocol/common/models';

export default function PersonalInfo(props: { contact: TAppContact }) {
  const email = props.contact.personalEmail?.displayEmail ?? props.contact.personalEmail?.emailAddress;
  const addressString = props.contact.personalAddress && ContactHelper.addressString(props.contact.personalAddress);
  let addressLink: ReactNode = null;
  if (addressString) {
    addressLink = <a target="google-maps" href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      addressString)}`}>{addressString}</a>;
  }

  return (
    <div className="mb-2">
      {
        email &&
        <ViewContactField>
          <a href={`mailto: ${email}`}>{email}</a>
        </ViewContactField>
      }
      {
        props.contact.personalMobile?.displayNumber &&
        <ViewContactField>
          <span>{props.contact.personalMobile.displayNumber}</span>
          {props.contact.personalMobile.label ?
            <ViewContactCaption>{props.contact.personalMobile.label}</ViewContactCaption> :
            <ViewContactCaption>Mobile</ViewContactCaption>
          }
        </ViewContactField>
      }
      {
        props.contact.personalLandline?.displayNumber &&
        <ViewContactField>
          <span>{props.contact.personalLandline.displayNumber}</span>
          {props.contact.personalLandline.label ?
            <ViewContactCaption>{props.contact.personalLandline.label}</ViewContactCaption> :
            <ViewContactCaption>Landline</ViewContactCaption>
          }
        </ViewContactField>
      }
      {
        (ContactHelper.toDateString(props.contact) !== '') &&
        <ViewContactField>
          <span>{ContactHelper.toDateString(props.contact)}</span>
          <ViewContactCaption>Birthday</ViewContactCaption>
        </ViewContactField>
      }
      {
        props.contact.personalAddress?.address1 &&
        <ViewContactField>
          {addressLink}
        </ViewContactField>
      }
      {
        props.contact.personalThirdPartyIds?.map((thirdPartyId: TAppThirdPartyId, idx: number) => {
          if (thirdPartyId.source && thirdPartyId.url && thirdPartyId.value) {
            return (
              <ViewContactField key={idx}>
                <ViewContactThirdPartyIcon alt={ThirdPartyName[thirdPartyId.source]}
                                           src={ThirdPartyIcon[thirdPartyId.source]}/>
                <ThirdPartyIdText onClick={() => openUrl(thirdPartyId.url)}>{thirdPartyId.value}</ThirdPartyIdText>
              </ViewContactField>
            );
          }
          return;
        })
      }
    </div>
  );
}
